<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Patrocinar Estudiante</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page lcu-page-noSpacing">
            <HeroBanner :image="'/assets/heroes/LCU-woman-laptop.png'">
                <section class="section">
                    <h3 class="lcu-hero-h3 lcu-center-text">
                        LEGACY CHRISTIAN UNIVERSITY
                    </h3>
                    <h1 class="lcu-hero-h1 lcu-center-text">
                        Patrocinar Estudiante
                    </h1>
                </section>
            </HeroBanner>
            <section class="section-public">
                <div class="section-container">
                    <div class="col-grid-2">
                        <div class="lcu-col-center">
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Invierte en el Llamado de un Estudiante
                                </h2>
                            </div>
                            <div class="row">
                                    En Legacy cnristan university creemos en el poder ae
                                    semorar en vidas con proposito. Al patrocinar a un estudiante
                                    no solo estas orindando acceso a educacion de calidad. sino
                                    tambien apoyando su crecimiento y desarrollo espiritua
                                    Tu aporte se convierte en una inversión eterna, ayudando a
                                    formar lideres comprometidos con su fe, preparados para impactar
                                    sus comunidades y llevar el mensaje de Cristo con excelencia y
                                    convicción.
                            </div>
                        </div>
                        <div class="lcu-col-center">
                            <img src="/assets/LCU-students.png" alt="LCU students" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-public-gray">
                <div class="section-container">
                    <div class="row">
                        <h3 class="lcu-hero-h3 lcu-center-text">
                            ¿Quisieras patrocinar un estudiante?
                        </h3>
                    </div>
                    <div class="row">
                        <p class="sponsor-student">
                            Si deseas patrocinar a un estudiante, te invitamos a enviarnos un correo electrónico.
                            Con gusto te compartiremos toda la información necesaria.
                            juntamente con los terminos y condiciones, para que puedas ser
                            parte de su formación, apoyando su educación y contribuyendo a transformar su futuro.
                        </p>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            <button-cta
                                :text="'Solicitar Información'"
                                @on-click="$router.push('/inscribirse')" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import HeroBanner from '@/components/hero-banner/HeroBanner.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';

export default {
  name: 'patrocinar-estudiante-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    SecondaryNav,
    ButtonCta,
    Footer,
    MobileControls,
    IphoneBar,
    HeroBanner,
  },
};
</script>

<style scoped lang="scss">
.lcu-col-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .row {
    width: 100%;
  }

  img {
    width: 500px;

    @media only screen and (max-width: $tablet-max) {
      width: 250px;
    }
    @media only screen and (max-width: $mobile-max) {
      width: 100%
    }
  }
}

.sponsor-student {
  width: 600px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;

  @media only screen and (max-width: $tablet-max) {
    width: 80%
  }

  @media only screen and (max-width: $mobile-max) {
    width: 100%
  }
}
</style>
